import { TextInput } from "risa-oasis-ui_v2";
import { TrashIcon } from "../../../../../shared/svg/trashIcon";
import { DX_CODE_ROW_TYPE_OPTIONS } from "../dxCodeRowTagOptions";
import { DxCodeEntry } from "../editDxCodeSidePanel";
import DxCodeRowTagFilterBar from "./DxCodeRowTagFilterBar";

interface DxCodesListProps {
  filteredDxCodes: DxCodeEntry[];
  dxCodes: DxCodeEntry[];
  hasPriorityConfig?: boolean;
  onDxCodeChange: (rowId: string, value: string) => void;
  onPriorityChange: (rowId: string, value: string) => void;
  onTypeChange: (rowId: string, value: string[]) => void;
  onDeleteCode: (rowId: string) => void;
}

const DxCodesList = ({
  filteredDxCodes,
  dxCodes,
  hasPriorityConfig,
  onDxCodeChange,
  onPriorityChange,
  onTypeChange,
  onDeleteCode,
}: DxCodesListProps) => {
  return (
    <div className="mb-6">
      {/* Headers - Sticky */}
      <div className="sticky top-0 z-10 mb-3 flex min-w-0 items-center gap-2.5 border-b border-[#e5e7eb] bg-white pb-3">
        <div className="w-[5.5rem] shrink-0 text-sm font-normal leading-[1.125rem]">
          DX Code
        </div>
        <div className="w-16 shrink-0 text-sm font-normal leading-[1.125rem]">
          Priority
        </div>
        <div className="min-w-0 flex-1 text-sm font-normal leading-[1.125rem]">
          Type
        </div>
        <div className="w-10 shrink-0"></div>
      </div>
      {/* Scrollable Rows Container */}
      <div className="max-h-[600px] overflow-y-auto">
        {!hasPriorityConfig && dxCodes.length === 0 ? (
          <div className="py-8 text-center text-sm text-gray-500">
            No priority defined for this organization
          </div>
        ) : dxCodes.length === 0 ? (
          <div className="py-8 text-center text-sm text-gray-500">
            No DX codes added yet
          </div>
        ) : filteredDxCodes.length === 0 ? (
          <div className="py-8 text-center text-sm text-gray-500">
            No DX codes match your search
          </div>
        ) : (
          filteredDxCodes.map((entry) => (
            <div
              key={entry.id}
              className="flex min-w-0 items-center gap-2.5 py-2"
            >
              <div className="w-[5.5rem] shrink-0">
                <TextInput
                  id={`dx-code-${entry.id}`}
                  label=""
                  placeholder="DX Code"
                  hideLabel={true}
                  onChange={(data) => onDxCodeChange(entry.id, data.value)}
                  defaultValue={entry.dxCode}
                />
              </div>
              <div className="w-16 shrink-0">
                <TextInput
                  id={`priority-${entry.id}`}
                  label=""
                  placeholder="Priority"
                  hideLabel={true}
                  onChange={(data) => onPriorityChange(entry.id, data.value)}
                  defaultValue={
                    entry.priority !== undefined
                      ? entry.priority.toString()
                      : "-"
                  }
                  type="text"
                />
              </div>
              <div className="min-w-0 flex-1">
                <DxCodeRowTagFilterBar
                  options={DX_CODE_ROW_TYPE_OPTIONS}
                  value={entry.source ?? []}
                  onChange={(ids) => onTypeChange(entry.id, ids)}
                  ariaLabel="DX code type"
                />
              </div>
              <div className="flex h-10 w-10 shrink-0 items-center">
                <div className="flex h-6 items-center gap-2.5 rounded border border-[#BB0202] p-1">
                  <button
                    className="flex cursor-pointer items-center justify-center border-none bg-transparent p-1 hover:opacity-70"
                    onClick={() => onDeleteCode(entry.id)}
                  >
                    <TrashIcon
                      width={16}
                      height={16}
                      className="h-4 w-4 text-[#BB0202]"
                    />
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default DxCodesList;
